(function () {
  var PANELS = {
    washes: {
      title: "Feminine Washes",
      href: "/collections/feminine-washes",
      products: [
        ["Refresh pH Balancing Wash", "/products/refresh-ph-balancing-yoni-gel"],
        ["Sensitive Probiotic+ Wash", "/products/sensitive-probiotic-ph-balanced-wash"],
        ["Refresh pH Wash · 3 pack", "/products/refresh-3pk"],
        ["Boric Balance Foam Wash", "/products/boric-balance"],
        ["Refreshing pH Duo", "/products/rfrsh-8z-borbal-duo"],
        ["Boric Balance · 3 pack", "/products/boric-balance-3pk"]
      ]
    },
    oils: {
      title: "Body Oils",
      href: "/collections/oils",
      products: [
        ["Yummy Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-yummy"],
        ["Sweet Skin Oil Bundle", "/products/sweet-skin-body-oil-bundle"],
        ["Vanilla Drip Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-vanilla-drip"],
        ["Pineapple Crème Body Splash Oil", "/products/body-splash-hydrating-body-oil-pineapple-creme"],
        ["Renew Her Yoni Oil", "/products/renew-her-booty-kitty-oil"],
        ["Fruity Skin Oil Bundle", "/products/fruity-skin-body-oil-bundle"]
      ]
    },
    "washes-body": {
      title: "Body Washes",
      href: "/collections/body-washes",
      products: [
        ["Yummy Organic Body Wash", "/products/yummy-body-gel-wash"],
        ["Vita C Bright Turmeric Wash", "/products/vita-c-bright-turmeric-body-wash"],
        ["Hydration Body Wash", "/products/dr-hydration-moisturizing-body-wash"],
        ["Body Wash Gift Set", "/products/body-wash-gift-set"],
        ["Charcoal Detox Body Wash", "/products/charcoal-detox-exfoliating-body-wash"],
        ["Yummy Wash · 3 pack", "/products/yummy-3pk"]
      ]
    },
    supplements: {
      title: "Supplements",
      href: "/collections/supplements",
      products: [
        ["Body Magic Chlorophyll Pills", "/products/body-magic-remove-full-body-odor-naturally"],
        ["Healthy Box Probiotics", "/products/healthy-box-probiotics"],
        ["Slippery Box Moisture Capsules", "/products/slippery-box-moisture-capsules"],
        ["Body Magic Chlorophyll · 3 pack", "/products/body-magic-3pk"],
        ["Healthy Box Probiotics · 3 pack", "/products/healthy-box-probiotics-3pk"],
        ["Slippery Box · 3 pack", "/products/3-bottles-of-slippery-increase-vaginal-moisture"]
      ]
    },
    bundles: {
      title: "Bundles & Kits",
      href: "/collections/bundle-deals",
      products: [
        ["Balance Bundle 2.0", "/products/the-balance-bundle-feminine-hygiene-self-care-products-copy"],
        ["Sweet Skin Oil Bundle", "/products/sweet-skin-body-oil-bundle"],
        ["The Everything Bundle", "/products/the-everything-bundle"],
        ["Her Fantasy Two Pack Wash", "/products/her-fantasy-two-pack-wash"],
        ["Fruity Skin Oil Bundle", "/products/fruity-skin-body-oil-bundle"],
        ["Date Night Set", "/products/date-night-set"]
      ]
    },
    intimate: {
      title: "Intimate Care",
      href: "/collections/suppositories",
      products: [
        ["Fresh & Clean Boric Suppositories", "/products/fresh-clean-ph-restore-capsules"],
        ["Fresh & Clean Kit", "/products/the-fresh-clean-kit"],
        ["Fresh & Clean · 3 pack", "/products/3-fresh-clean-bottles"]
      ]
    },
    odor: {
      title: "Body odor",
      href: "/collections/body-odor",
      products: [
        ["Yummy Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-yummy"],
        ["Body Magic Chlorophyll Pills", "/products/body-magic-remove-full-body-odor-naturally"],
        ["Refresh pH Balancing Wash", "/products/refresh-ph-balancing-yoni-gel"],
        ["Balance Bundle 2.0", "/products/the-balance-bundle-feminine-hygiene-self-care-products-copy"],
        ["Sweet Skin Oil Bundle", "/products/sweet-skin-body-oil-bundle"],
        ["Vanilla Drip Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-vanilla-drip"]
      ]
    },
    fresh: {
      title: "Intimate freshness",
      href: "/collections/vag-odor",
      products: [
        ["Body Magic Chlorophyll Pills", "/products/body-magic-remove-full-body-odor-naturally"],
        ["Refresh pH Balancing Wash", "/products/refresh-ph-balancing-yoni-gel"],
        ["Fresh & Clean Boric Suppositories", "/products/fresh-clean-ph-restore-capsules"],
        ["Healthy Box Probiotics", "/products/healthy-box-probiotics"],
        ["Boric Balance Foam Wash", "/products/boric-balance"],
        ["Fresh & Clean Kit", "/products/the-fresh-clean-kit"]
      ]
    },
    dry: {
      title: "Dryness",
      href: "/collections/vag-dryness",
      products: [
        ["Slippery Box Moisture Capsules", "/products/slippery-box-moisture-capsules"],
        ["Renew Her Yoni Oil", "/products/renew-her-booty-kitty-oil"],
        ["Her Fantasy Starter Kit", "/products/her-fantasy-starter-kit"],
        ["Before Intimacy Kit", "/products/before-intimacy-kit"],
        ["Moisture Support Kit", "/products/moisture-support-hydration-kit"]
      ]
    },
    spots: {
      title: "Dark spots",
      href: "/collections/dark-spots",
      products: [
        ["Yummy Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-yummy"],
        ["Vanilla Drip Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-vanilla-drip"],
        ["Pineapple Crème Body Splash Oil", "/products/body-splash-hydrating-body-oil-pineapple-creme"],
        ["Renew Her Yoni Oil", "/products/renew-her-booty-kitty-oil"],
        ["Caramel Glaze Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-caramel-glaze"],
        ["Lavender & Vanilla Body Splash Oil", "/products/body-splash-skin-smoothing-body-oil-mental-reset-lavender"]
      ]
    },
    comfort: {
      title: "Skin comfort",
      href: "/collections/ingrown-hairs",
      products: [
        ["Renew Her Yoni Oil", "/products/renew-her-booty-kitty-oil"],
        ["Bright Even Skin Kit", "/products/bright-even-skin-kit"]
      ]
    }
  };

  function catalog() {
    if (catalog.data) return catalog.data;
    var node = document.querySelector("[data-hfb-078-catalog]");
    try {
      catalog.data = node ? JSON.parse(node.textContent) : {};
    } catch (error) {
      catalog.data = {};
    }
    return catalog.data;
  }

  function handleFromHref(href) {
    var match = (href || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function stars(info) {
    var rating = parseFloat(info && info.rating);
    var count = parseInt(info && info.count, 10);
    if (!rating) return "";
    var label = "★ " + rating.toFixed(1);
    if (count) label += " (" + count.toLocaleString("en-US") + ")";
    return '<span class="hfb-078__card-stars">' + label + "</span>";
  }

  function cardHtml(item) {
    var handle = handleFromHref(item[1]);
    var info = catalog()[handle] || {};
    var photo = info.img
      ? '<img src="' + info.img + '" alt="" width="320" height="320">'
      : '<img alt="" width="320" height="320" data-hfb-078-pending="' + handle + '">';
    var rating = stars(info);
    return (
      '<li><a class="hfb-078__card" href="' + item[1] + '">' +
      '<span class="hfb-078__card-photo">' + photo + "</span>" +
      '<span class="hfb-078__card-name">' + item[0] + "</span>" +
      '<span class="hfb-078__card-meta"><span class="hfb-078__card-price">' + (info.price || "") + "</span>" +
      (rating || "") +
      "</span></a></li>"
    );
  }

  function fillMissing(list) {
    list.querySelectorAll("[data-hfb-078-pending]").forEach(function (img) {
      var handle = img.getAttribute("data-hfb-078-pending");
      fetch("/products/" + handle + ".js")
        .then(function (res) { return res.json(); })
        .then(function (product) {
          if (product.featured_image) img.src = product.featured_image;
          var price = img.closest(".hfb-078__card").querySelector(".hfb-078__card-price");
          if (price && product.price) price.textContent = "$" + (product.price / 100).toFixed(2);
          img.removeAttribute("data-hfb-078-pending");
        })
        .catch(function () {});
    });
  }

  function root() {
    return document.querySelector("[data-hfb-078]");
  }

  function showHome() {
    var nav = root();
    if (!nav) return;
    nav.querySelector("[data-hfb-078-home]").hidden = false;
    nav.querySelector("[data-hfb-078-panel]").hidden = true;
  }

  function openPanel(key) {
    var panel = PANELS[key];
    var nav = root();
    if (!panel || !nav) return;
    nav.querySelector("[data-hfb-078-title]").textContent = panel.title;
    var all = nav.querySelector("[data-hfb-078-all]");
    all.setAttribute("href", panel.href);
    var list = nav.querySelector("[data-hfb-078-products]");
    list.innerHTML = panel.products.map(cardHtml).join("");
    fillMissing(list);
    nav.querySelector("[data-hfb-078-home]").hidden = true;
    nav.querySelector("[data-hfb-078-panel]").hidden = false;
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-hfb-078-open]");
    if (opener) {
      event.preventDefault();
      openPanel(opener.getAttribute("data-hfb-078-open"));
      return;
    }
    if (event.target.closest("[data-hfb-078-back]")) {
      event.preventDefault();
      showHome();
    }
  }, true);
})();
